export const postScheduleCollaboratorInitialState = {
	schedule: null,
	error: null,
	errorShow: false,
	loading: false,
};
